var AgentFlag;
(function (AgentFlag) {
  AgentFlag["REI_LOGO_ACT"] = "REI_LOGO_ACT";
  AgentFlag["REI_LOGO_NSW"] = "REI_LOGO_NSW";
})(AgentFlag || (AgentFlag = {}));
export default AgentFlag;